import { render, staticRenderFns } from "./CompanyMembers.vue?vue&type=template&id=326a5108&scoped=true&"
import script from "./CompanyMembers.vue?vue&type=script&lang=js&"
export * from "./CompanyMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326a5108",
  null
  
)

export default component.exports